import React, { useEffect, useState } from "react";
import { API, UPLOADS } from "../../config/api";
import "./../Styles/WorkBidsModal.css";
const RatingStars = ({ rating, ratingCount }) => {
  const value = Number(rating || 0);

  return (
    <div className="wb-rating-wrapper">
      <div className="wb-rating-stars">
        {[1, 2, 3, 4, 5].map((star) => {
          let icon = "bi-star";

          if (value >= star) {
            icon = "bi-star-fill";
          } else if (value >= star - 0.5) {
            icon = "bi-star-half";
          }

          return (
            <i
              key={star}
              className={`bi ${icon} ${
                icon === "bi-star"
                  ? "wb-star-empty"
                  : "wb-star-active"
              }`}
            ></i>
          );
        })}
      </div>

   <span className="wb-rating-number">
  {value > 0 ? value.toFixed(1) : "0.0"}
</span>

      {/* <span className="wb-rating-count">
        ({ratingCount || 0})
      </span> */}
    </div>
  );
};
export default function WorkBidsModal({
  show,
  onClose,
  work,
  user,
  onAccepted,
}) {
  const BASE_URL = API || `${API.BASE_URL}/payment.php`;

  const [loading, setLoading] = useState(false);
  const [accepting, setAccepting] = useState(false);

  const [bids, setBids] = useState([]);
const [showPaymentModal, setShowPaymentModal] = useState(false);
const [paymentMethod, setPaymentMethod] = useState("");
const [selectedBid, setSelectedBid] = useState(null);
  const [error, setError] = useState("");
const displayStatus = (status) => {
  const normalized = (status || "").trim().toLowerCase();

  if (normalized === "paid") {
    return "Completed";
  }

  return status || "Pending";
};
  // -------------------------------
  // Fetch all bids
  // -------------------------------
const fetchBids = async () => {
  if (!work) {
    console.log("No work selected");
    return;
  }

  setLoading(true);
  setError("");

  try {
    // Use direct URL (don't use API constant for now)
    const url = `${API.BASE_URL}/api.php?action=get_work_bids&work_id=${work.id}&owner_id=${user.id}`;

    console.log("Request URL:", url);

    const response = await fetch(url);

    console.log("HTTP Status:", response.status);

    const text = await response.text();

    console.log("Raw Response:", text);

    const result = JSON.parse(text);

    console.log("Parsed Result:", result);

    if (result.status) {
      console.log("Bids:", result.data);
      setBids(result.data || []);
    } else {
      setError(result.message || "No data found");
    }
  } catch (err) {
    console.error("Fetch Error:", err);
    setError(err.message);
  }

  setLoading(false);
};
  // -------------------------------
  // Accept Bid
  // -------------------------------

  const acceptBid = async (bid) => {
  if (!window.confirm(`Accept bid for ₹${bid.price}?`)) {
    return;
  }

  setAccepting(true);

  try {
    const formData = new FormData();
    formData.append("work_id", work.id);
    formData.append("bid_id", bid.id);
    formData.append("owner_id", user.id);

    const response = await fetch(
      `${API.BASE_URL}/api.php?action=accept_work_bid`,
      {
        method: "POST",
        body: formData,
      }
    );

    console.log("HTTP Status:", response.status);

    const text = await response.text();

    console.log("Raw Response:", text);

    const result = JSON.parse(text);

    alert(result.message);

    if (result.status) {
      fetchBids();

      if (onAccepted) {
        onAccepted();
      }
    }
  } catch (err) {
    console.error(err);
    alert(err.message);
  }

  setAccepting(false);
};
  // -------------------------------
  // Badge Color
  // -------------------------------

  const badgeClass = (status) => {
  status = (status || "").toLowerCase().trim();

  if (status === "accepted") return "accepted";

  if (status === "rejected") return "rejected";

  if (status === "paid" || status === "completed") return "completed";

  return "pending";
};

  // -------------------------------

  useEffect(() => {
    if (show) {
      fetchBids();
    }
  }, [show]);

  if (!show) return null;
 const payWithRazorpay = async (bid) => {
  let orderId = "";
  let paymentCompleted = false;
  let paymentFailed = false;

  try {
    const formData = new FormData();
    formData.append("work_id", work.id);
    formData.append("bid_id", bid.id);
    formData.append("owner_id", user.id);

    const response = await fetch(
      `${API.BASE_URL}/payment.php?action=create_work_payment`,
      {
        method: "POST",
        body: formData,
      }
    );

    const result = await response.json();

    if (!result.success) {
      alert(result.message);
      return;
    }

    orderId = result.order_id;

    const options = {
      key: result.key,
      amount: result.amount,
      currency: result.currency,
      name: "Embroidery Bazar",
      description: "Designer Work Payment",
      order_id: result.order_id,

      // =========================================
      // PAYMENT SUCCESS
      // =========================================
      handler: async function (payment) {
        try {
          const verify = await fetch(
            `${API.BASE_URL}/payment.php?action=verify_work_payment`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                razorpay_order_id: payment.razorpay_order_id,
                razorpay_payment_id: payment.razorpay_payment_id,
                razorpay_signature: payment.razorpay_signature,
              }),
            }
          );

          const verifyResult = await verify.json();

          if (verifyResult.success) {
            paymentCompleted = true;

            setShowPaymentModal(false);
            setPaymentMethod("");
            setSelectedBid(null);

            alert("Payment Successful");

            fetchBids();

            if (onAccepted) {
              onAccepted();
            }
          } else {
            alert(
              verifyResult.message ||
                "Payment verification failed."
            );
          }
        } catch (error) {
          console.error("Payment verification error:", error);
          alert("Payment verification failed.");
        }
      },

      // =========================================
      // RAZORPAY POPUP CLOSED / EXIT
      // =========================================
      modal: {
        ondismiss: async function () {
          // Do NOT mark Cancelled if payment already succeeded
          // or Razorpay already reported payment failure.
          if (paymentCompleted || paymentFailed) {
            return;
          }

          try {
            await fetch(
              `${API.BASE_URL}/payment.php?action=cancel_work_payment`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  razorpay_order_id: orderId,
                }),
              }
            );

            setShowPaymentModal(false);
            setPaymentMethod("");
            setSelectedBid(null);

            alert("Payment Cancelled");

            fetchBids();

            if (onAccepted) {
              onAccepted();
            }
          } catch (error) {
            console.error(
              "Cancel payment error:",
              error
            );
          }
        },
      },

      // =========================================
      // USER INFORMATION
      // =========================================
      prefill: {
        name: user?.name || "",
        email: user?.email || "",
        contact: user?.phone || "",
      },

      theme: {
        color: "#0c2e3b",
      },
    };

    const rzp = new window.Razorpay(options);

    // =========================================
    // PAYMENT FAILED
    // =========================================
    rzp.on("payment.failed", async function (response) {
      paymentFailed = true;

      console.error(
        "Razorpay payment failed:",
        response
      );

      try {
        await fetch(
          `${API.BASE_URL}/payment.php?action=fail_work_payment`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              razorpay_order_id: orderId,
              error: response.error || null,
            }),
          }
        );
      } catch (error) {
        console.error(
          "Failed payment status update error:",
          error
        );
      }

      alert(
        response?.error?.description ||
          "Payment Failed"
      );

      setShowPaymentModal(false);
      setPaymentMethod("");
      setSelectedBid(null);

      fetchBids();

      if (onAccepted) {
        onAccepted();
      }
    });

    rzp.open();
  } catch (err) {
    console.error("Payment creation error:", err);
    alert("Unable to create payment.");
  }
};
const openPaymentModal = (bid) => {
  setSelectedBid(bid);
  setPaymentMethod("");
  setShowPaymentModal(true);
};
  return (
  <div className="wb-modal-overlay">
    <div className="wb-modal w-auto">

      {/* Header */}

      <div className="wb-header">

        <div>
          <h3>Received Bids</h3>

          <p>
            {work?.description}
          </p>
        </div>

        <button
          className="wb-close"
          onClick={onClose}
        >
          ×
        </button>

      </div>

      {/* Loading */}

      {loading && (
        <div className="wb-loading">

          <div className="spinner-border text-primary"></div>

          <p>Loading bids...</p>

        </div>
      )}

      {/* Error */}

      {!loading && error && (
        <div className="alert alert-danger">

          {error}

        </div>
      )}

      {/* Empty */}

      {!loading &&
        !error &&
        bids.length === 0 && (
          <div className="wb-empty">

            <i className="bi bi-people"></i>

            <h4>No Bids Yet</h4>

            <p>
              Designers haven't submitted any bids yet.
            </p>

          </div>
        )}

      {/* Table */}

      {!loading &&
        bids.length > 0 && (

          <div className="table-responsive">

            <table className="table table-bordered align-middle">

             <thead>
  <tr>
    <th>#</th>
    <th>Date</th>
    <th>Price</th>
   <th>Rating</th>
<th>Total Completed Work </th>
<th>Status</th>
    <th>Action</th>
  </tr>
</thead>

              <tbody>

                {bids.map((bid,index) => (

                  <tr key={bid.id}>
<td>{bids.length - index}</td>
      <td>
                            {new Date(bid.created_at).toLocaleDateString(
                              "en-GB",
                            )}
                          </td>
                    {/* <td>

                      <img
                        src={
                          bid.profile_image
                            ? `${UPLOADS.PROFILE_IMAGE}/${bid.profile_image}`
                            : "/images/user.png"
                        }
                        alt=""
                        className="wb-avatar"
                      />

                    </td>

                    <td>

                      <strong>

                        {bid.name}

                      </strong>

                    </td>

                    <td>

                      {bid.phone}

                    </td> */}

                   <td>
  ₹ {Number(bid.price).toLocaleString()}
</td>

<td>
  <RatingStars
    rating={bid.rating}
    ratingCount={bid.rating_count}
  />
</td>

<td className="text-center">
  <strong>
    {Number(bid.rating_count || 0)}
  </strong>
</td>



<td>
 <span
                              className={`vwk-bid-status-badge vwk-bid-status-${(
                                bid.status || "neutral"
                              )
                                .toLowerCase()
                                .trim()
                                .replace(/\s+/g, "-")}`}
                            >
    {displayStatus(bid.status)}
  </span>
</td>
                    <td>

                   {bid.status === "Pending" ? (
  <button
    className="btn btn-success btn-sm"
    disabled={accepting}
    onClick={() => acceptBid(bid)}
  >
    {accepting ? "Please wait..." : "Accept"}
  </button>

) : bid.status === "Accepted" ? (

 <button
  className="btn btn-primary btn-sm"
  onClick={() => openPaymentModal(bid)}
>
  <i className="bi bi-credit-card"></i> Make Payment
</button>
) : (
  bid.status === "Start Work" ||
  bid.status === "In Progress" ||
  bid.status === "Work in Review" ||
  bid.status === "Completed" ||
  bid.status === "Paid"
) ? (

  <span className="text-muted">-</span>

) : (

  <span className="text-danger">Rejected</span>

)}
                    </td>

                  </tr>

                ))}

              </tbody>

            </table>

          </div>

        )}

            <div className="wb-footer">
        <button
          className="btn btn-secondary"
          onClick={onClose}
        >
          Close
        </button>
      </div>

    </div>

    {/* ================= PAYMENT POPUP ================= */}
    {showPaymentModal && (
      <div className="ad-modal-overlay">
        <div
          className="ad-modal-content p-3"
          style={{
            maxWidth: "450px",
            textAlign: "center",
          }}
        >

          {/* Popup Header */}
          <div className="ad-modal-header pb-3 m-0">
            <h4 className="mb-0">Select Payment Method</h4>

            <button
              className="btn-close-custom"
              onClick={() => {
                setShowPaymentModal(false);
                setPaymentMethod("");
                setSelectedBid(null);
              }}
            >
              <i className="bi bi-x-lg"></i>
            </button>
          </div>

          {/* Popup Body */}
          <div className="ad-modal-body p-0">

            {/* Amount */}
            {selectedBid && (
              <p className="mt-3 mb-3 fw-bold">
                Amount:{" "}
                <strong>
                  ₹{Number(selectedBid.price).toLocaleString("en-IN")}
                </strong>
              </p>
            )}

            {/* ================= PAYMENT METHODS ================= */}
            {!paymentMethod && (
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  justifyContent: "center",
                }}
              >

                {/* Google Pay */}
                <button
                  className="btn btn-light"
                  onClick={() => setPaymentMethod("gpay")}
                >
                  <img
                    src="/images/gpay.png"
                    alt="Google Pay"
                    style={{
                      width: "120px",
                      height: "60px",
                      objectFit: "contain",
                    }}
                  />
                </button>

                {/* Razorpay */}
                <button
                  className="btn btn-light"
                  onClick={() => {
                    if (selectedBid) {
                      setShowPaymentModal(false);
                      setPaymentMethod("");
                      payWithRazorpay(selectedBid);
                    }
                  }}
                >
                  <img
                    src="/images/razorpay.png"
                    alt="Razorpay"
                    style={{
                      width: "120px",
                      height: "60px",
                      objectFit: "contain",
                    }}
                  />
                </button>

              </div>
            )}

            {/* ================= GOOGLE PAY QR ================= */}
            {paymentMethod === "gpay" && selectedBid && (
              <div className="text-center mt-4">

                <p
                  className="mt-3 fw-bold"
                  style={{ fontSize: "13px" }}
                >
                  Scan using Google Pay
                </p>

                <img
                  src="/images/qr.jpeg"
                  alt="Google Pay QR"
                  className="payment-qr"
                />

                <p className="mt-3 fw-bold">
                  Amount:{" "}
                  <strong>
                    ₹{Number(selectedBid.price).toLocaleString("en-IN")}
                  </strong>
                </p>

                <p className="mt-3 text-danger fw-bold">
                  After Payment Send Screenshot And Call on <br />
                  +91 9909614445
                </p>

              </div>
            )}

          </div>
        </div>
      </div>
    )}

  </div>
);
}